import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: modules,
  strict: true,
  // リロードしてもstoreの値を保持する（ログインの永続化）
  // paths内に記載したstateはsessionStrageに保存する
  plugins: [createPersistedState({
      key: 'ENGetThrough',
      paths: ['user', 'master', 'notification', 'conditions', 'apply', 'school', 'account', 'enrollment'],
      storage: window.sessionStorage
  })],

  state: {
    currentPath: '',
    drawer: false,
  },

  mutations: {
    setCurrentPath(state, payload) {
      state.currentPath = payload.path;
    },
    setDrawer(state, payload) {
      state.drawer = payload.drawer;
    },
  },
})
